var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"app-bar",attrs:{"color":"#D9D9D9","elevation":"0"}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.activeDrawer}}),(_vm.comebackRoute)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v(" mdi-arrow-left ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }